import { render } from "./ListeModePaiementPage.vue?vue&type=template&id=2ebddd35&ts=true"
import script from "./ListeModePaiementPage.vue?vue&type=script&lang=ts"
export * from "./ListeModePaiementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__